const module = {
  config: {
    name: 'setup-landing-page',
    icon: 'ri-settings-6-line',
    desc: '',
    group: 'Lainnya',
    layout: true
  },
  routes: [
    { name: 'vision-missions', label: 'Visi dan Misi', icon: null, path: '/vision-missions', component: () => import('./missions.vue') },
    { name: 'banners', label: 'Update Banner', icon: null, path: '/banners', component: () => import('./banners.vue') },
    { name: 'organization-structures', label: 'Struktur Organisasi', icon: null, path: '/organization-structures', component: () => import('./organization-structures.vue') },
    { name: 'sekar-compartments', label: 'Program Kerja', icon: null, path: '/sekar-compartments', component: () => import('./sekar-compartments.vue') },
    { name: 'footer', label: 'Konfigurasi Footer', icon: null, path: '/footer', component: () => import('./footer-crud.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/config-landing/_index.js